"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeParamsSchema = exports.EventCountParamsSchema = exports.EventMarkerParamsSchema = exports.EventMarkerFieldSchema = exports.EventParamsSchema = exports.ParamsWithSpatialSchema = exports.EventFieldSchema = exports.AttributeSchema = exports.EventFilterUrlParamsSchema = exports.EventUrlParamsSchema = void 0;
const zod_1 = require("zod");
const util_1 = require("./util");
const event_1 = require("./event");
const util_2 = require("../util");
const query_1 = require("./query");
const translationQuery_1 = require("./translationQuery");
/**
 * This schema is used to control the controls that are made available in the Swagger docs.
 */
exports.EventUrlParamsSchema = zod_1.z.object({
    offset: query_1.OffsetSchema,
    limit: query_1.LimitSchema,
    fieldQueries: query_1.FieldQueriesSchema.extend((0, query_1.generateFieldQueryObject)(query_1.SpatialOperators, query_1.SpatialSchema)).optional(),
});
/**
 * This schema is used to control the controls that are made available in the Swagger docs
 * for endpoints which don't support pagination (i.e. when the response is not an array)
 */
exports.EventFilterUrlParamsSchema = zod_1.z.object({
    fieldQueries: query_1.FilterFieldQueriesSchema.extend((0, query_1.generateFieldQueryObject)(query_1.SpatialOperators, query_1.SpatialSchema)).optional(),
});
const eventKeys = [...(0, util_2.zodKeys)(event_1.EventWithRelsWithoutAttributesSchema), 'event.start', 'event.end'];
const refineAttributes = (schema) => schema.refine(val => {
    if (/event\.attributes/.test(val))
        return /event\.attributes\..+/.test(val);
    return eventKeys.includes(val);
}, {
    message: `field must be one of:
${eventKeys.join(', \n  ')}.
event.attributes must be a string of the form "event.attributes.<attribute>".`,
});
exports.AttributeSchema = (0, util_2.superKeySchema)('event.attributes');
exports.EventFieldSchema = refineAttributes(zod_1.z.union([
    ...(0, util_1.schemaKeys)(event_1.EventWithRelsWithoutAttributesSchema),
    ...(0, util_1.schemaKeys)(event_1.EventLocationFieldsSchema),
    (0, util_2.superKeySchema)('event.attributes'),
]));
const FilterParamsWithSpatialSchema = (0, query_1.filterParamsSchema)(exports.EventFieldSchema).extend((0, query_1.generateFilterParamsObject)(query_1.SpatialOperators, zod_1.z.record(exports.EventFieldSchema, query_1.SpatialSchema).optional()));
exports.ParamsWithSpatialSchema = FilterParamsWithSpatialSchema.extend((0, query_1.offsetLimitOrderBy)(exports.EventFieldSchema)).strict();
exports.EventParamsSchema = exports.ParamsWithSpatialSchema.extend(translationQuery_1.LanguageParamsSchema.shape).strict();
exports.EventMarkerFieldSchema = refineAttributes(zod_1.z.union([
    ...(0, util_1.schemaKeys)(zod_1.z.object({
        event: event_1.EventWithoutAttributesSchema,
    })),
    exports.AttributeSchema,
]));
exports.EventMarkerParamsSchema = exports.ParamsWithSpatialSchema.strict();
exports.EventCountParamsSchema = FilterParamsWithSpatialSchema.strict();
exports.EventTypeParamsSchema = FilterParamsWithSpatialSchema.strict();
//# sourceMappingURL=eventQuery.js.map